import BoxWrapper from "../../../components/BoxWrapper";
import Pagination from "../../../components/Pagination";
import RenderTable from "../../../components/RenderTable";
import { pluralize } from "../../../helpers/general";
import AdminRoute from "../../auth/RestrictedRoute";
import { useMultiPlaceAdminInvoicesQuery } from "../../../hooks/invoices/useInvoicesQuery";
import { useQueryParam } from "../../../hooks/useQueryParam";
import { general } from "../../../locales/general";
import InvoicesTable from "./InvoicesTable";
import { ROLES } from "../../../config/constants";
import { useState } from "react";
import { CModal } from "@coreui/react";
import { GenerateInvoiceModal } from "./GenerateInvoiceModal";

const PAGE_SIZE = 20;

export default function InvoicesPage() {
  const { add } = useQueryParam();
  // const [searchParams] = useSearchParams();
  const [generateInvoiceModalVisible, setGenerateInvoiceModalVisible] =
    useState(false);

  const { invoices, isLoading, totalPages, totalItems, currentPage } =
    useMultiPlaceAdminInvoicesQuery();

  return (
    <AdminRoute route={ROLES.PLACE_ADMIN} requireMultiPlaceAdmin={true}>
      <h5 className="fs-4 fw-bold mb-2">Factures</h5>
      <BoxWrapper>
        <div className="d-flex  justify-content-between align-items-baseline before-table">
          <div className="d-flex align-items-center gap-2 p-3 delete-add">
            <button
              onClick={() => setGenerateInvoiceModalVisible(true)}
              className="outline-none border-0 btn btn-primary rounded-pill text-white d-flex align-items-center gap-2 justify-content-center shadow-secondary"
            >
              + Générer une facture
            </button>
          </div>
          <div className="d-flex flex-column-reverse flex-md-row  justify-content-end">
            <div className="d-flex align-items-center justify-content-between">
              <div
                className="d-flex align-items-center justify-content-center gap-3 bg-gradient-primary p-3 w-100"
                style={{ borderTopRightRadius: "8px" }}
              >
                <p className="fs-5 fw-bold m-0  text-white">
                  {totalItems} {pluralize("Facture", totalItems)}
                </p>
              </div>
            </div>
          </div>
        </div>
        <RenderTable
          loading={isLoading}
          render={() =>
            invoices?.length > 0 ? (
              <InvoicesTable invoices={invoices} />
            ) : (
              <p className="text-center fs-5 my-2">{general.fr.noData}</p>
            )
          }
        />
      </BoxWrapper>
      <Pagination
        currentPage={currentPage as any}
        onPageChange={(page) => {
          add("page", page.toString());
        }}
        siblingCount={1}
        totalCount={totalPages}
        pageSize={PAGE_SIZE}
      />
      {/* // * Modals */}
      <CModal
        size="lg"
        alignment="center"
        visible={generateInvoiceModalVisible}
        onClose={() => setGenerateInvoiceModalVisible(false)}
      >
        <GenerateInvoiceModal
          onClose={() => setGenerateInvoiceModalVisible(false)}
        />
      </CModal>
    </AdminRoute>
  );
}
